<script setup lang="ts">
import { ref } from "vue"
import { KirbyBlock } from "../../../queries/blocks"
import PreviewWrapper from "@/components/StudentPage/PreviewWrapper.vue"

const props = defineProps<{
  block: KirbyBlock<"video">
  ratio?: number
  aspect?: number
}>()

defineEmits<{
  open: []
}>()

const isVideoVisible = ref(false)
const videoUrl = props.block.content.url

// Utility: Extract YouTube ID
function getYouTubeVideoId(url: string): string | null {
  const match = url.match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/|v\/)|youtu\.be\/)([a-zA-Z0-9_-]+)(?:\?|&|$)/,
  )
  return match ? match[1] : null
}

// Get thumbnail URL
const thumbnailUrl = ref<string | null>(null)

if (videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be")) {
  const id = getYouTubeVideoId(videoUrl)
  thumbnailUrl.value = id
    ? `https://img.youtube.com/vi/${id}/hqdefault.jpg`
    : null
} else if (videoUrl.includes("vimeo.com")) {
  fetch(`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(videoUrl)}`)
    .then(res => (res.ok ? res.json() : null))
    .then(data => {
      if (data && data.thumbnail_url) {
        thumbnailUrl.value = data.thumbnail_url
      }
    })
}
</script>
<template>
  <div
    :id="block.id"
    class="relative w-full h-full overflow-hidden aspect-video cursor-pointer"
    @click="$emit('open')"
  >
    <template v-if="block.content.url">
      <!-- Show thumbnail if video not yet playing -->
      <div
        class="flex items-center justify-center w-full h-full"
        v-if="!isVideoVisible"
      >
        <img
          v-if="thumbnailUrl"
          :src="thumbnailUrl"
          alt="Video thumbnail"
          class="object-contain"
        />
        <!-- Optional play icon overlay -->
        <div
          class="absolute inset-0 flex items-center justify-center text-white"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-20 h-20 fill-white drop-shadow-lg"
            viewBox="0 0 64 64"
          >
            <polygon points="26,20 48,32 26,44" fill="white" />
          </svg>
        </div>
      </div>
    </template>

    <div v-else class="p-4 text-white bg-red-600">
      <div>Empty video block.</div>
    </div>
  </div>
</template>
